"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AgentListingsResponse$ = exports.AgentListingsResponse$outboundSchema = exports.AgentListingsResponse$inboundSchema = void 0;
exports.agentListingsResponseToJSON = agentListingsResponseToJSON;
exports.agentListingsResponseFromJSON = agentListingsResponseFromJSON;
const z = __importStar(require("zod"));
const schemas_js_1 = require("../../../lib/schemas.js");
const agentlistingwrapper_js_1 = require("./agentlistingwrapper.js");
const datameta_js_1 = require("./datameta.js");
/** @internal */
exports.AgentListingsResponse$inboundSchema = z.object({
    data: z.array(agentlistingwrapper_js_1.AgentListingWrapper$inboundSchema),
    meta: datameta_js_1.DataMeta$inboundSchema,
});
/** @internal */
exports.AgentListingsResponse$outboundSchema = z.object({
    data: z.array(agentlistingwrapper_js_1.AgentListingWrapper$outboundSchema),
    meta: datameta_js_1.DataMeta$outboundSchema,
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var AgentListingsResponse$;
(function (AgentListingsResponse$) {
    /** @deprecated use `AgentListingsResponse$inboundSchema` instead. */
    AgentListingsResponse$.inboundSchema = exports.AgentListingsResponse$inboundSchema;
    /** @deprecated use `AgentListingsResponse$outboundSchema` instead. */
    AgentListingsResponse$.outboundSchema = exports.AgentListingsResponse$outboundSchema;
})(AgentListingsResponse$ || (exports.AgentListingsResponse$ = AgentListingsResponse$ = {}));
function agentListingsResponseToJSON(agentListingsResponse) {
    return JSON.stringify(exports.AgentListingsResponse$outboundSchema.parse(agentListingsResponse));
}
function agentListingsResponseFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.AgentListingsResponse$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'AgentListingsResponse' from JSON`);
}
//# sourceMappingURL=agentlistingsresponse.js.map